const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export default function(date, dontShowSameYear = false) {
    if (date == null || typeof date !== 'number') return ''
    const dateObj = new Date(date)
    let fullYear = dateObj.getFullYear()
    if(new Date().getFullYear() === fullYear && dontShowSameYear)
        fullYear = ''
    else
        fullYear += ','
    return `${months[dateObj.getMonth()]} ${dateObj.getDate()}, ${fullYear} ${dateObj.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}`
}
